<template>
  <div class="createProject">
    <div class="page-title">{{title}}</div>
    <el-form ref="projectForm" :model="projectForm" :rules="projectRules" class="form" label-width="140px">
      <el-form-item label="项目名称" prop="name">
        <el-input v-model="projectForm.name" placeholder="请输入项目名称"></el-input>
      </el-form-item>
      <el-form-item label="所属产品" prop="products">
        <el-select v-model="projectForm.products" placeholder="请选择所属产品" :disabled="productDisabled">
          <el-option v-for="item in productList" :key="item.id" :label="item.productName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-bottom:60px;" label="分配投放账户" prop="account">
        <div class="category">
          <div class="icon tt active"></div>
        </div>
        <el-transfer
          v-model="projectForm.account"
          filterable
          :titles="['未选择', '已选择']"
          :format="{
            noChecked: '0/${total}',
            hasChecked: '${checked}/${total}'
          }"
          @change="handleChange"
          :data="assignAccountList">
        </el-transfer>
      </el-form-item>
      <el-form-item label="项目团队成员" prop="employeeIdList">
        <el-select v-model="projectForm.employeeIdList" multiple collapse-tags placeholder="请选择所属项目团队成员">
          <el-option v-for="item in employeeList" :key="item.id" :label="item.employeeName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('projectForm')" class="fl">确认创建</el-button>
        <el-button @click="backupView()">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// 表单验证
import { notNullable, notNullableChange, sizeMax } from '@/components/form/formValidation'

export default {
  name: 'createProject',
  data () {
    // const generateData = _ => {
    //   const data = []
    //   for (let i = 1; i <= 15; i++) {
    //     data.push({
    //       key: i,
    //       label: '新华新媒数据技术' + i,
    //       disabled: i % 4 === 0
    //     })
    //   }
    //   return data
    // }
    return {
      title: '创建项目',
      productDisabled: false,
      assignAccountList: [],
      employeeList: [],
      projectForm: {
        name: '',
        products: '',
        employeeIdList: [],
        account: []
      },
      projectRules: {
        name: [
          notNullable('请填写项目名称'),
          sizeMax('项目名称', 40)
        ],
        products: [
          notNullableChange('请选择所属产品')
        ],
        account: [
          // notNullable('请选择要分配的账户')
        ],
        employeeIdList: [notNullable('请选择项目团队成员')]
      }
    }
  },
  props: {
    productList: {
      type: Array,
      required: true
    },
    activeProductId: {
      // type: String,
      required: true
    }
  },
  created () {

  },
  mounted () {
    this.activeProduct(this.activeProductId)
    this.getAccountList()
    this.getChargeManList()
  },
  methods: {
    backupView() {
      if (this.$route.path.startsWith('/qianchuan')) {
        this.$router.push('/qianchuan/account/project')
      } else {
        this.$router.push('/accountManage/projectManage')
      }
    },
    // 获取投放账号数据
    getAccountList () {
      this.$service.post('/api/project/getAccountList4Select').then(res => {
        // set数据
        let list = []
        let num = 0
        res.result.forEach((item, index) => {
          if (item.assignedStatus === 1) {
            item.assignedStatus = true
          } else {
            item.assignedStatus = false
          }
          list[num] = {
            'key': item.id,
            'label': item.agentAccountName,
            'disabled': item.assignedStatus
          }
          num += 1
        })
        this.assignAccountList = list
        // console.log(this.assignAccountList)
      }).catch(Err => {

      })
    },
    getChargeManList() {
      this.$service.post('/api/project/getChargeManList').then(res => {
        this.employeeList = res.result || []
      }).catch(Err => {

      })
    },
    // 获取预设产品
    activeProduct (id) {
      // console.log(id)
      if (id === 0) {
        console.log('无预设产品')
      } else {
        this.projectForm.products = id
        this.productDisabled = true
      }
    },
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.projectForm)
          this.$service.post('/api/project/saveProject', {
            'productId': this.projectForm.products,
            'projectName': this.projectForm.name,
            'accountIdList': this.projectForm.account,
            'employeeIdList': this.projectForm.employeeIdList
          }).then(res => {
            this.$message({
              showClose: true,
              message: '创建成功，即将为您跳转列表页',
              type: 'success',
              duration: 1000
            })
            setTimeout(() => {
              this.backupView()
            }, 1000)
          }).catch(Err => {

          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleChange (value, direction, movedKeys) {
      // console.log(value, direction, movedKeys)
      // console.log(this.projectForm.account)
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="less">
@import './../../styles/accountManage/createProject.less';
</style>



// WEBPACK FOOTER //
// src/views/accountManage/createProject.vue